export const promotionEndpoints = {
    invitations: {
        placeholderList: {
            api: '/api/mercury/invitations/placeholders/list',
            method: 'GET',
            parameter: true
        },
        staticPlaceholders: {
            api: '/api/mercury/invitations/placeholders/static-list',
            method: 'GET',
            parameter: false
        },
        sendBulkInvitations: {
            api: '/api/seller-invitation/bulk-add',
            method: 'POST',
            parameter: false
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/promotion.endpoints.ts